export const radioButtonLaraThemeConfig = {
  colorScheme: {
    light: {
      background: "white",
      checkedBackground: "{primary.600}",
      borderColor: "{gray.300}",
      checkedBorderColor: "{primary.600}",
      iconCheckedColor: "white",
      iconSmSize: "8px",
    },
  },
  sm: {
    width: "16px",
    height: "16px",
  },
  css: ({ dt }: any) => `
    .p-radiobutton-checked:not(.p-disabled):has(.p-radiobutton-input:focus) .p-radiobutton-box {
      outline: 2px solid white;
      box-shadow: 0px 0px 0px 4px #9E77ED, 0px 0px 0px 2px #FFFFFF;
    }
  `,
};
